import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsModuleRoutes } from '../../settings-routes';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  templateUrl: './settings-overview.component.html',
  styleUrls: ['./settings-overview.component.scss']
})
export class SettingsOverviewComponent extends BaseWithBundleComponent implements OnInit, OnDestroy {

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public isSettingsOverview(): boolean {
    const currentRoute = this.router.routerState.snapshot.url;
    return currentRoute === `/${SettingsModuleRoutes.SETTINGS}`;
  }
}
